// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.title[data-v-55737836] {\r\n  font-weight: 600;\r\n  font-size: 22px;\r\n  line-height: 33px;\r\n  letter-spacing: 0.15px;\r\n  color: #494949;\r\n  margin: 1rem 0 0 0;\n}\n.select[data-v-55737836] {\r\n  margin-top: 0.5rem;\r\n  max-width: 50vw;\n}\r\n", ""]);
// Exports
module.exports = exports;
